import _ from 'lodash';
import store from "services/redux/store";
import { dataConstants } from "services/redux/data/constants";
import ObjectClass from "utils/objects/object";
import ObjectBuilding from "utils/objects/building";
import ObjectFloor from "utils/objects/floor";

export default class ObjectLunchOption {
	
	static log = ( value ) => {
		console.prefix('LunchOption', value );
	}
	
	static get = ( objects ) => {
		return ObjectClass.get( objects, dataConstants.LUNCH_OPTIONS );
	}
	
	static getOptions = ( { building = {}, floor = {} } = {} ) => {
		let options = [];
		
		if( !_.isEmpty( building ) ) {
			building = {
				...building,
				...ObjectBuilding.first( building.guid )
			}
		}
		
		if( !_.isEmpty( floor ) ) {
			floor = {
				...floor,
				...ObjectFloor.first( floor.guid )
			}
		}
		
		const list = [ building, floor ];
		
		_.forEach( list, object => {
			if( !_.isEmpty( object ) ) {
				const c = _.get( object, 'lunch_options', false );
				
				if( c !== false ) {
					const tmpOptions = this.find( c );
					
					if( !_.isEmpty( tmpOptions ) ) {
						options = tmpOptions;
					}
				}
			}
		});
		
		return this.order( options );
	}
	
	static getOptionsByBookings = ( bookings ) => {
		let allOptions = {};
		_.forEach( bookings, booking => {
			const options = this.getOptions( booking );
			
			if( _.size( options ) > 0 ) {
				allOptions = {
					...allOptions,
					...options
				}
			}
		});
		
		return allOptions;
	}
	
	static find( options ) {
		const _lunchOptions = store.getState().data[ dataConstants.LUNCH_OPTIONS ];
		
		const lunchOptions = [];
		
		_.forEach( options, option => {
			const lunchOption = _.get( _lunchOptions, _.get( option, [ 'lunch_option', 'guid' ], null ), {} );
			
			if( !_.isEmpty( lunchOption ) && ObjectClass.isActive( lunchOption ) ) {
				lunchOptions.push( lunchOption );
			}
		});
		
		return this.order( lunchOptions );
	}
	
	static filter = ( objects ) => {
		return ObjectClass.filterActive( objects );
	}
	
	static order = ( options ) => {
		return _.orderBy( options, ['default', 'position', 'name'], ['desc', 'asc', 'asc'] );
	}
	
	static filterAndOrder = ( objects ) => {
		return this.order( this.filter( objects ) );
	}
}
